import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m2 8 2 2-2 2 2 2-2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 8-2 2 2 2-2 2 2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "VibrateOff";
const VibrateOff = memo(themed(Icon));
export {
  VibrateOff
};
//# sourceMappingURL=vibrate-off.js.map
